import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

export type UseCreateAgentBaseEligibilityResult = {
	hasBaseEligibility: boolean;
};

export const useCreateAgentBaseEligibility = (): UseCreateAgentBaseEligibilityResult => {
	const { cloudId, isRovoLLMEnabled, accessStatus, isLoggedIn } = useSessionData();
	const isAnonymousUser = accessStatus === AccessStatus.ANONYMOUS_ACCESS || !isLoggedIn;

	return {
		hasBaseEligibility: isRovoLLMEnabled && !isAnonymousUser && !!cloudId,
	};
};
